// os : organization space
export const SharedAccessPatternOsList = [
  "GetLockers",
  "GetClients",
  "GetConfigurationsByTenant",
  "GetCredentialsByUser",
  "GetGroupIamActions",
  "GetGroupsByTenant",
  "GetGroupTUsByGroupId",
  "GetGroupTUsByTenantAndUser",
  "GetLockerById",
  "GetLockerCurrentReservations",
  "GetReservationAuds",
  "GetReservationAudsById",
  "GetReservationById",
  "GetReservations",
  "GetSstReservations",
  "GetUsersByTenant",
  "GetReservationAttemptByExternalId",
  "GetFeatureAssignmentsByTenantId",
  "GetFeatures",
  "GetCurrentSmsDeliveries",
  "GetSmsDeliveriesByReservationId",
] as const;

export const SharedAccessPatternOsEnum = {
  GetLockers: "GetLockers",
  GetClients: "GetClients",
  GetConfigurationsByTenant: "GetConfigurationsByTenant",
  GetCredentialsByUser: "GetCredentialsByUser",
  GetGroupIamActions: "GetGroupIamActions",
  GetGroupsByTenant: "GetGroupsByTenant",
  GetGroupTUsByGroupId: "GetGroupTUsByGroupId",
  GetGroupTUsByTenantAndUser: "GetGroupTUsByTenantAndUser",
  GetLockerById: "GetLockerById",
  GetLockerCurrentReservations: "GetLockerCurrentReservations",
  GetReservationAuds: "GetReservationAuds",
  GetReservationAudsById: "GetReservationAudsById",
  GetReservationById: "GetReservationById",
  GetReservations: "GetReservations",
  GetSstReservations: "GetSstReservations",
  GetUsersByTenant: "GetUsersByTenant",
  GetReservationAttemptByExternalId: "GetReservationAttemptByExternalId",
  GetFeatureAssignmentsByTenantId: "GetFeatureAssignmentsByTenantId",
  GetFeatures: "GetFeatures",
  GetCurrentSmsDeliveries: "GetCurrentSmsDeliveries",
  GetSmsDeliveriesByReservationId: "GetSmsDeliveriesByReservationId",
} as const;

export type SharedAccessPatternOsName =
  (typeof SharedAccessPatternOsList)[number];

// us : user space
export const SharedAccessPatternUsList = [
  "GetMe",
  "GetIamActions",
  "GetMods",
  "GetResources",
  "GetMyTenants",
] as const;

export const SharedAccessPatternUsEnum = {
  GetMe: "GetMe",
  GetIamActions: "GetIamActions",
  GetMods: "GetMods",
  GetResources: "GetResources",
  GetMyTenants: "GetMyTenants",
} as const;

export type SharedAccessPatternUsName =
  (typeof SharedAccessPatternUsList)[number];

// sa : super admin space
export const SharedAccessPatternSaList = [
  "GetItemByKeys",
  "SaGetEmailExpeditors",
  "SaGetLockers",
  "SaGetLockersMetrics",
  "SaSearchLockers",
  "SaGetMeventLogByThingType",
  "SaGetMeventLogByTrace",
  "SaGetReservationAudsByEmployeeCode",
  "SaGetReservationAudsByEvent",
  "SaGetSeedTrackers",
  "SaGetSmsExpeditors",
  "SaGetTenantsByUser",
  "SaGetTenants",
  "SaGetUsers",
  "SaGetSmsDeliveries",
  "SaGetEmailDeliveries",
  "SaGetEmailDeliverybyId",
  "SaGetEmailDeliveriesByEventType",
  "SaGetEmailDeliveryEventsByEmailDeliveryId",
  "SaGetDeletedThings",
  "SaGetAdminLogs",
  "SaGetFeatures",
  "SaGetFeatureById",
  "SaGetFeatureAssignments",
  "SaGetFeatureAssignmentById",
  "SaGetFeatureAssignmentsByFeatureId",
  "SaGetFeatureAssignmentsByTenantId",
  "SaGetSstv2Migrations",
  "SaGetSstv2MigrationFailures",
  "SaGetSstv2EvidenceRuns",
  "SaGetReservationSyncs",
  "SaGetSl1ImportJobs",
  "SaGetSl1ImportFleet",
] as const;

export const SharedAccessPatternSaEnum = {
  GetItemByKeys: "GetItemByKeys",
  SaGetEmailExpeditors: "SaGetEmailExpeditors",
  SaGetLockers: "SaGetLockers",
  SaGetLockersMetrics: "SaGetLockersMetrics",
  SaSearchLockers: "SaSearchLockers",
  SaGetMeventLogByThingType: "SaGetMeventLogByThingType",
  SaGetMeventLogByTrace: "SaGetMeventLogByTrace",
  SaGetReservationAudsByEmployeeCode: "SaGetReservationAudsByEmployeeCode",
  SaGetReservationAudsByEvent: "SaGetReservationAudsByEvent",
  SaGetSeedTrackers: "SaGetSeedTrackers",
  SaGetSmsExpeditors: "SaGetSmsExpeditors",
  SaGetTenantsByUser: "SaGetTenantsByUser",
  SaGetTenants: "SaGetTenants",
  SaGetUsers: "SaGetUsers",
  SaGetSmsDeliveries: "SaGetSmsDeliveries",
  SaGetEmailDeliveries: "SaGetEmailDeliveries",
  SaGetEmailDeliverybyId: "SaGetEmailDeliverybyId",
  SaGetEmailDeliveriesByEventType: "SaGetEmailDeliveriesByEventType",
  SaGetEmailDeliveryEventsByEmailDeliveryId:
    "SaGetEmailDeliveryEventsByEmailDeliveryId",
  SaGetDeletedThings: "SaGetDeletedThings",
  SaGetAdminLogs: "SaGetAdminLogs",
  SaGetFeatures: "SaGetFeatures",
  SaGetFeatureById: "SaGetFeatureById",
  SaGetFeatureAssignments: "SaGetFeatureAssignments",
  SaGetFeatureAssignmentById: "SaGetFeatureAssignmentById",
  SaGetFeatureAssignmentsByFeatureId: "SaGetFeatureAssignmentsByFeatureId",
  SaGetFeatureAssignmentsByTenantId: "SaGetFeatureAssignmentsByTenantId",
  SaGetSstv2Migrations: "SaGetSstv2Migrations",
  SaGetSstv2MigrationFailures: "SaGetSstv2MigrationFailures",
  SaGetSstv2EvidenceRuns: "SaGetSstv2EvidenceRuns",
  SaGetReservationSyncs: "SaGetReservationSyncs",
  SaGetSl1ImportJobs: "SaGetSl1ImportJobs",
  SaGetSl1ImportFleet: "SaGetSl1ImportFleet",
} as const;

export type SharedAccessPatternSaName =
  (typeof SharedAccessPatternSaList)[number];
